import { ErrorMessage, Field } from 'formik';
import React from 'react';
import { FiSearch } from 'react-icons/fi';

const IconInput = ({
  label,
  type,
  name,
  id,
  placeholder,
  value,
  setFieldTouched,
  handleSubmit,
}) => {
  return (
    <div className='flex w-full flex-col'>
      {label ? (
        <label htmlFor={id} className='text-sm font-medium leading-none text-brand-navy'>
          {label}
        </label>
      ) : null}
      <div className='relative mt-1'>
        <Field
          className='flex h-9 w-full rounded-md border border-input bg-transparent pl-3 pr-9 py-1 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          onKeyUp={(e) => {
            setFieldTouched(name, true);
            e.key === 'Enter' && handleSubmit();
          }}
        />
        <FiSearch
          size={16}
          className='pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground'
        />
      </div>
      <ErrorMessage
        name={name}
        render={(msg) => (
          <div className='mt-2 flex gap-1 text-left text-[12px] font-normal leading-none text-red-700'>
            {msg}
          </div>
        )}
      />
    </div>
  );
};

export default IconInput;
